module.exports = __webpack_public_path__ + "img/im_logo_black@2x.9811f647.png";